import { render } from "./PropProdReg.vue?vue&type=template&id=24c225ac&scoped=true"
import script from "./PropProdReg.vue?vue&type=script&lang=js"
export * from "./PropProdReg.vue?vue&type=script&lang=js"

import "./PropProdReg.vue?vue&type=style&index=0&id=24c225ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c225ac"]])

export default __exports__